import React from 'react';
import classnames from 'classnames';

import Button from 'components/UI/Button';
import Icon from 'components/UI/Icon';

import useIntersection from 'hooks/useIntersection';
import useLocaleTxt from 'hooks/useLocaleTxt';

import * as styles from './styles.module.scss';

const Join = () => {
  const { scrollWrapper, inViewSec, inViewRefSec } = useIntersection({
    threshold: 0.7,
  });
  const localeTxt = useLocaleTxt();

  return (
    <section className={styles.joinsec} ref={scrollWrapper}>
      <div
        className={classnames(
          'cr-wrap',
          styles.join,
          inViewSec && styles.jsAnimInit
        )}
        ref={inViewRefSec}
      >
        <div className={styles.join_img}></div>
        <div className={styles.join_txt}>
          <div className={styles.jointxt}>
            <h2 className={classnames('cr-h2 cr-txt-1', styles.jointxt_title)}>
              {localeTxt['JOIN_TITLE']}
            </h2>
            <p
              className={classnames('cr-reg cr-txt-2', styles.jointxt_subtitle)}
            >
              {localeTxt['JOIN_SUB_TITLE']}
            </p>
            <Button
              className={classnames(
                'cr-btn--icon cr-btn--large cr-btn--wide cr-btn--icon-red-bg'
              )}
            >
              {localeTxt['JOIN_BTN']}
              <Icon name="corner-arrow-small-bold" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Join;
